var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconToolBarMaBs(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/Icon_ToolBar_MABs"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 4C0 1.79086 1.79086 0 4 0H57C59.2091 0 61 1.79086 61 4V57C61 59.2091 59.2091 61 57 61H4C1.79086 61 0 59.2091 0 57V4ZM19.4091 6.93182H13.8636V12.4773H8.31818V18.0227H13.8636V23.5682H19.4091V18.0227H24.9545V12.4773H19.4091V6.93182ZM9.46626 39.7293L13.3875 35.8081L17.3088 39.7294L21.2304 35.8078L25.1517 39.729L21.23 43.6506L25.1512 47.5718L21.2299 51.493L17.3088 47.5719L13.388 51.4927L9.46675 47.5714L13.3876 43.6506L9.46626 39.7293ZM36.0455 18.0227V12.4773H52.6818V18.0227H36.0455ZM36.0455 40.2045V36.0455H52.6818V40.2045H36.0455ZM36.0455 51.2955V47.1364H52.6818V51.2955H36.0455Z",
    fill: "#FEDE79"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconToolBarMaBs);
export default __webpack_public_path__ + "static/media/Icon_ToolBar_MABs.bf4af7dffbafa3eb8fe8d88d8133feaf.svg";
export { ForwardRef as ReactComponent };